import { memo, ReactNode } from 'react'
import { Checkbox, CheckboxProps, forwardRef } from '@chakra-ui/react'
import { Controller } from 'react-hook-form'

type CustomCheckboxProps = CheckboxProps & { control: any; name: string; children: ReactNode }

const CustomCheckbox = forwardRef<CustomCheckboxProps, 'input'>(({ children, ...rest }, ref) => {
  rest.control
  return (
    <Controller
      name={rest.name}
      control={rest.control}
      render={({ field: { value } }) => (
        <Checkbox ref={ref} isChecked={value} {...rest}>
          {children}
        </Checkbox>
      )}
    />
  )
})

export default memo(CustomCheckbox)
